import { NotificationDto } from '@timechef/core/api/models/notification-dto';
import { ensureDate } from '@timechef/core/utils';
import { isSameDay, subDays } from 'date-fns';
import { NotificationsByPeriod, NotificationsPeriodEnum } from './notifications.models';

// Do not store this grouping because it changes every day, instead we compute it on the fly when required
export const computeNotifications = (today: Date, dtos: NotificationDto[], existing?: NotificationsByPeriod[]): NotificationsByPeriod[] => {
  const notificationsByPeriod: NotificationsByPeriod[] = existing || [
    { period: NotificationsPeriodEnum.Today, items: [] },
    { period: NotificationsPeriodEnum.Yesterday, items: [] },
    { period: NotificationsPeriodEnum.Previously, items: [] },
  ];

  const yesterday = subDays(today, 1);

  dtos.forEach((notification) => {
    const date = ensureDate(notification.date);
    if (isSameDay(date, today)) getNotificationsByPeriod(notificationsByPeriod, NotificationsPeriodEnum.Today)!.push(notification);
    else if (isSameDay(date, yesterday)) getNotificationsByPeriod(notificationsByPeriod, NotificationsPeriodEnum.Yesterday)!.push(notification);
    else getNotificationsByPeriod(notificationsByPeriod, NotificationsPeriodEnum.Previously)!.push(notification);
  });

  return notificationsByPeriod;
};

export const getNotificationsByPeriod = (notifications: NotificationsByPeriod[], period: NotificationsPeriodEnum) =>
  notifications.find((x) => x.period === period)?.items;
